<template>
  <div>
  <va-dropdown
    class="notification-dropdown"
    offset="0, 16px"
    boundary-body
  >
    <va-icon-notification
      slot="anchor"
      class="notification-dropdown__icon notification-dropdown__icon--unread"
      :color="contextConfig.invertedColor ? $themes.gray : 'white'"
    />
    <div class="notification-dropdown__content pl-3 pr-3 pt-2 pb-2">
      <div
        v-for="option in notifications"        
        class="notification-dropdown__item row pt-1 pb-1 mt-2 mb-2 notification-dropdown__item--unread"
      >        
        <span class="ellipsis" style="max-width: 95%;">
          {{ option.message }}
        </span>
      </div>
      <div class="row justify--space-between">
        <va-button class="ma-0 mb-2 mt-1" small @click="viewall">{{ $t('notifications.all') }}</va-button>
      </div>
    </div>   
  </va-dropdown>
  <va-modal
      v-model="showModal"
      position="top"
      size = "large"
      :fullscreen = "fullscreen"
      :mobileFullscreen = "fullscreenmobile"
      :title=" $t('notifications')"
      cancelClass="none"      
      :okText=" $t('modal.close') "     
      :cancelText=" $t('modal.cancel')"      
  >
    <template v-for="(notification, i) in notifications">
      <va-item>
        <va-item-section avatar>
          <avatar :username="tostring(i+1)" :color="spinnersColor"></avatar>
        </va-item-section>
        <va-item-section>
          <va-item-label>
            {{ notification.message }}
          </va-item-label>

          <va-item-label caption>
            {{ notification.date_sent | formatDate }} {{ notification.time_sent }}
          </va-item-label>      

        </va-item-section>    
      </va-item>
    </template>
  </va-modal>
</div>
</template>

<script>
import axios from 'axios'
import VaIconNotification from '../../../../../iconset/VaIconNotification'
import { ColorThemeMixin } from '../../../../../services/vuestic-ui'
import Avatar from 'vue-avatar'

export default {
  name: 'notification-dropdown',
  inject: ['contextConfig'],
  components: {
    VaIconNotification,
    Avatar
  },
  mixins: [ColorThemeMixin],
  data () {
    return {
      showModal:false,
      fullscreen:false,
      fullscreenmobile:true,
      spinnersColor: '#537c3d',
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      token: JSON.parse(localStorage.getItem('Token')),
      notifications: {},
    }
  },
  methods:{
    tostring(val){
      return val.toString();
    },
    viewall(){
      this.showModal = true;
    },
    GetNotifications () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetNotifications`, self.userData.user_id, config)
        .then(function (res) {
          res = res.data
          self.notifications = res 

        })
        .catch(function (error) {
          console.log(error)
      })
    },
  },
  created(){
    this.GetNotifications();
  }
}
</script>

<style lang="scss">

.notification-dropdown {
  cursor: pointer;

  .notification-dropdown__icon {
    position: relative;
    display: flex;
    align-items: center;

    &--unread::before {
      content: '';
      position: absolute;
      right: 0;
      left: 0;
      top: -0.5rem;
      background-color: $brand-danger;
      height: 0.375rem;
      width: 0.375rem;
      margin: 0 auto;
      border-radius: 0.187rem;
    }
  }

  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: 0.5rem;
    max-width: 19rem;
  }

  &__item {
    cursor: pointer;
    margin-bottom: 0.75rem;
    color: $brand-secondary;
    flex-wrap: nowrap;
    position: relative;

    &--unread {
      color: $vue-darkest-blue;

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        height: 0.375rem;
        width: 0.375rem;
        background-color: $brand-danger;
        margin: auto;
        border-radius: 0.187rem;
      }
    }

    &:hover {
      color: $vue-green;
    }

    &__avatar {
      border-radius: 50%;
      width: 1.5rem;
      height: 1.5rem;
      min-width: 1.5rem;
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
